/**
 * Utility functions for detecting and handling subdomain-based routing
 */

/**
 * Checks if the current hostname is the VC subdomain
 * Returns true for venture.sendupdates.ai or localhost:3006
 */
export const isVCSubdomain = (): boolean => {
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // Production VC subdomain
  if (hostname === 'venture.sendupdates.ai') {
    return true;
  }
  
  // Local development on port 3006
  if (hostname === 'localhost' && port === '3006') {
    return true;
  }
  
  return false;
};

/**
 * Returns the base URL for the current environment
 */
export const getBaseUrl = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return isVCSubdomain() ? 'http://localhost:3006' : 'http://localhost:3005';
  }
  
  return isVCSubdomain() ? 'https://venture.sendupdates.ai' : 'https://app.sendupdates.ai';
};

/**
 * Returns the appropriate frontend URL for redirects
 */
export const getFrontendUrl = (): string => {
  return getBaseUrl();
};

